
import { Vue } from "vue-class-component";

import opaqueColor from "@/opaqueColor";

export default class Base extends Vue {
  id = "control_id";
  defaultText = "Default Text";
  text = "";

  mounted() {
    this.text = this.$store.state.text[this.id]
      ? this.$store.state.text[this.id].text
      : this.defaultText || "";
  }

  beforeUnmount() {
    this.updateText();
  }

  opaqueColor(fg: string, bg: string): string {
    return opaqueColor(fg, bg);
  }

  selectText(e: Event) {
    const s = window.getSelection();
    if (s) {
      s.selectAllChildren(e.target as Node);
    }
  }

  updateText() {
    const text = (this.$refs[this.id] as HTMLElement).innerText;
    this.$store.commit("changeText", {
      id: this.id,
      style: window.getComputedStyle(this.$refs[this.id] as HTMLElement),
      text,
    });
  }
}
